import { render, staticRenderFns } from "./CardTarjaEnqueteFechamentoSportvWithQRCode.vue?vue&type=template&id=39993050&scoped=true"
import script from "./CardTarjaEnqueteFechamentoSportvWithQRCode.vue?vue&type=script&lang=js"
export * from "./CardTarjaEnqueteFechamentoSportvWithQRCode.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaEnqueteFechamentoSportvWithQRCode.vue?vue&type=style&index=0&id=39993050&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39993050",
  null
  
)

export default component.exports